import { Base } from '../base-component';

import { AnalyticsService } from '../../services/analytics.service';

import axios, {
	AxiosResponse,
	AxiosPromise,
	AxiosRequestConfig
} from 'axios';

import * as $ from 'jquery';

import './form-item-generic-form.component.scss';

export class FormItemGenericForm extends Base {

	// form
	form: HTMLFormElement;
	callmebackFormId: any;
	buttonSubmit: Element[];
	selectTitle: any;
	radioFeedbackType: any;
	valuesJson: any = {
	};

	// INPUTS
	formInputRecipient: any;
	formInputEmail: any;
	formInputSubject: any;
	formInputSuccess: any;

	// NEW
	formTitleName: any;
	formValueName: any;
	formValueEmail: any;
	formValueRecipient: any;
	formValueSubject: any;
	formValueFeedbackType: any;
	formValueFrmcontainer: any;
	formValueSuccessMessage: any;

	constructor(element: Element) {

		super(element);

	}

	init() {

		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.selectTitle = this.element.querySelector('.js-title');
		this.buttonSubmit = Array.from(this.element.querySelectorAll('.js-apply-now__button'));
		this.radioFeedbackType = Array.from(this.element.querySelectorAll('.js-feedback-type__radio'));

		if (this.element.getAttribute('data-formname')) {

			this.formValueName = this.element.getAttribute('data-formname');

			let parent = this.element.closest('.form-container');

			if(this.element.closest('.form-container') {

				let parent = this.element.closest('.form-container');

				if(parent.querySelector('.apply-now__title--module-title')) {

					let title = parent.querySelector('.apply-now__title--module-title');
					title.innerHTML = this.formValueName;

				}

			}

		}

		if (this.element.getAttribute('data-recipient')) {

			this.formValueRecipient = this.element.getAttribute('data-recipient');

			if (this.element.querySelector('input[name=recipient]')) {

				this.formInputRecipient = this.element.querySelector('input[name=recipient]');
				this.formInputRecipient.value = this.formValueRecipient;

			}

		}

		if (this.element.getAttribute('data-email')) {

			this.formValueEmail = this.element.getAttribute('data-email');

			if (this.element.querySelector('input[name=email]')) {

				this.formInputEmail = this.element.querySelector('input[name=email]');
				this.formInputEmail.value = this.formValueEmail;

			}

		}

		if (this.element.getAttribute('data-subject')) {

			this.formValueSubject = this.element.getAttribute('data-subject');

			if (this.element.querySelector('input[name=subject]')) {

				this.formInputSubject = this.element.querySelector('input[name=subject]');
				this.formInputSubject.value = this.formValueSubject;

			}

		}

		if (this.element.getAttribute('data-frmcontainer')) {

			this.formValueFrmcontainer = this.element.getAttribute('data-frmcontainer');
			this.form.setAttribute('data-frmcontainer', this.formValueFrmcontainer);

		}

		if (this.element.getAttribute('data-successmessage')) {

			this.formValueSuccessMessage = this.element.getAttribute('data-successmessage');

			if(this.element.querySelector('.js-apply-now-success-message')) {

				this.formInputSuccess = this.element.querySelector('.js-apply-now-success-message');
				this.formInputSuccess.innerHTML = '<h4 class="title title--module-sub-title text-center enquiry__title">' + this.formValueSuccessMessage +'</h4>';

			}

		}

	}

	bindEvents() {

		if(this.radioFeedbackType) {
			this.radioFeedbackType.map((item) => item.addEventListener('click', (event) => {
				let element: any = event.target;
				if (element.value == "compliment") {
					this.formValueFeedbackType = 'compliment';
				} else {
					this.formValueFeedbackType = 'complaint';
				}
			}));
		}

		if(this.selectTitle) {
			this.selectTitle.addEventListener('change', (event) => {
				let element = event.target;
				this.addMoreTitle(element);
			});
		}

		if(this.buttonSubmit) {
			this.buttonSubmit.map((item) => item.addEventListener('click', (event) => {
				const formFields: any = this.form.querySelectorAll('input, select, textarea');
				const validation = this.validationService.validate(formFields);
				const valid = Array.from(this.form.querySelectorAll(".form__group--error"));
				if (valid.length == 0) {
	
					if (this.valuesJson.feedbackType !== "") {
	
						this.actionForm(this.form, this.element.querySelector('.form__loader--container'), this.element.querySelector('.form__thankyou--container'));
	
					} else {
	
						this.radioFeedbackType.map((item, index) => {
							let parent = item.closest('.form__group');
							parent.classList.add('form__group--error');
						});
	
					}
	
				}
			}));
		}

		$(document).on('click', '.js-apply-now-modal-open', (event) => {
			let element = event.target;
			let modal = $(element).attr('data-modal');
			if (modal) {
				this.callmebackFormId = modal;
			}
		});

	}

	addMoreTitle(element) {
		if (element) {
			if (element.value == 'Other') {

				let parentParent = element.closest('.form__fields--container');
				let parent = element.closest('.form__group');

				let newContainer = document.createElement('div');
				newContainer.classList.add('form__group');
				newContainer.classList.add('js-other-title-container');

				let newLabel = document.createElement('label');
				newLabel.classList.add('form__label');
				newLabel.innerHTML = 'Other Title';
				newContainer.appendChild(newLabel);

				let newInput = document.createElement('input');
				newInput.classList.add('js-other-title');
				newInput.classList.add('form__input');
				newInput.classList.add('form__input--required');
				newInput.setAttribute('placeholder', 'Enter your title');
				newInput.setAttribute('maxlength', '4');
				newInput.setAttribute('name', 'other-title');
				newContainer.appendChild(newInput);

				parentParent.insertBefore(newContainer, parent.nextSibling);

			} else {
				let parentParent = element.closest('.form__fields--container');
				let oldInput = this.element.querySelector('.js-other-title-container');
				if (oldInput) {
					parentParent.removeChild(oldInput);
				}
			}
		}
	}

	resetForm() {
		if (this.form) {
			this.form.reset();
			let formContainerLoader = this.element.querySelector('.form__loader--container');
			let formContainerFields = this.element.querySelector('.form__fields--container');
			let formContainerThankyou = this.element.querySelector('.form__thankyou--container');
			formContainerThankyou.classList.remove('active');
			formContainerFields.classList.remove('hidden');
		}
	}

	actionForm(form: HTMLFormElement, loader: Element, thankyou: Element) {

		// fields
		const recipient: any = this.form.querySelector('input[name=recipient]');
		const email: any = this.form.querySelector('input[name=email]');
		const subject: any = this.form.querySelector('input[name=subject]');
		const redirect: any = this.form.querySelector('input[name=redirect]');

		const product: any = this.form.querySelector('input[name=product]');
		const title: any = this.form.querySelector('select[name=title]');
		const titleOther: any = form.querySelector('input[name=other-title]');
		const firstName: any = form.querySelector('input[name=first-name]');
		const surname: any = form.querySelector('input[name=surname');
		const telephone: any = form.querySelector('input[name=telephone-number');
		const emailAddress: any = form.querySelector('input[name=emailAddress');
		const comments: any = form.querySelector('textarea[name=comments');
		const pageUrl: any = window.location.href;

		let postData = '';
		if (this.formValueFeedbackType) {
			postData += 'feedbackType=' + this.formValueFeedbackType + '&';
		}
		if (recipient) {
			postData += 'recipient=' + recipient.value + '&';
		}
		if (email) {
			postData += 'email=' + email.value + '&';
		}
		if (subject) {
			postData += 'subject=' + subject.value + '&';
		}
		if (redirect) {
			postData += 'redirect=' + redirect.value + '&';
		}
		if (product) {
			postData += 'productName=' + product.value + '&';
		}
		if (title) {
			if (titleOther) {
				postData += 'title=' + titleOther.value + '&';
			} else {
				postData += 'title=' + title.value + '&';
			}
		}
		if (firstName) {
			postData += 'firstName=' + firstName.value + '&';
		}
		if (surname) {
			postData += 'surname=' + surname.value + '&';
		}
		if (telephone) {
			postData += 'tel=' + telephone.value + '&';
		}
		if (emailAddress) {
			postData += 'emailAddress=' + emailAddress.value + '&';
		}
		if (comments) {
			postData += 'comments=' + comments.value + '&';
		}
		if (this.callmebackFormId) {
			postData += 'callmebackFormId=' + this.callmebackFormId + '&';
		}
		if (pageUrl) {
			postData += 'pageUrl=' + pageUrl + '&';
		}

		// loader + hide form
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		loader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/SubmitGenericForm.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		axios.post(url, postData, config).then(function (response) {
			// service ok
			loader.classList.remove('active');
			analyticsService.dtmFormComplete('complete', '');
			loader.classList.remove('active');
			thankyou.classList.add('active');

		}).catch(function (response) {
			// service failed
			analyticsService.dtmFormComplete('complete', '');
			loader.classList.remove('active');
			thankyou.classList.add('active');

		});

	}

}



// WEBPACK FOOTER //
// ./components/form-item-generic-form/form-item-generic-form.component.ts